import { Stack, Typography } from '@mui/material'
import type { FC, PropsWithChildren } from 'react'
import { useTranslation } from 'react-i18next'
import { type To } from 'react-router'

import { unit } from '@hcr/ui'

import { LayoutNavigationBack, Metadata } from '../../../../common'

interface LayoutHistoryProps extends PropsWithChildren {
  backNavigationPath: To
}

export const LayoutHistory: FC<LayoutHistoryProps> = ({ backNavigationPath, children }) => {
  const { t } = useTranslation()

  return (
    <LayoutNavigationBack to={backNavigationPath} arrowVariant='text'>
      <Metadata title={t('page-title.history')} />
      <Stack gap={unit(4)} paddingTop={unit(24)} paddingX={unit(7)} paddingBottom={unit(4.5)}>
        <Typography component='h1' variant='headlineL'>
          {t('history.booking-history')}
        </Typography>
        <Typography component='h2' variant='bodyM'>
          {t('history.here-you-can-view-all-your-bookings')}
        </Typography>
      </Stack>
      {children}
    </LayoutNavigationBack>
  )
}
